import { useTranslation } from "react-i18next";
import { useAPI } from "../../../lib/common";
import React, { useMemo } from "react";
import { getTemplateTranslation } from "../../Providers/TemplateInstanceProvider";
import i18next from "i18next";
import useTemplateList from "../../hooks/useTemplateList";
import useGoogleFonts from "../../SPA/hooks/useGoogleFonts";
import { templateFontList } from "../../SPA/Components/EditTemplateProduct/common";
import SubHeader from "../../SPA/Components/SubHeader";
import { Skeleton } from "@material-ui/lab";
import ProductsWithTemplates from "./ProductsWithTemplates";
const PhotogiftListPageContent = ({ category }) => {
    const type = 'photogift';
    const [t] = useTranslation();
    const [categoryInfo] = useAPI(`/m/api/templates/photogift/categories/` + category + "/info");
    const categoryName = useMemo(() => {
        if (!categoryInfo) {
            return "";
        }
        return getTemplateTranslation(categoryInfo.names, i18next.language);
    }, [categoryInfo]);
    const [templateList, loadingTemplates] = useTemplateList(type, category);
    const { loaded: fontsLoaded } = useGoogleFonts(templateFontList);
    const separateFromBackground = categoryInfo ? categoryInfo.separateFromBackground : false;
    return (React.createElement(React.Fragment, null,
        React.createElement(SubHeader, { title: categoryName || React.createElement(Skeleton, { variant: "text" }), subtitle: t("Choose template") || '' }),
        React.createElement(ProductsWithTemplates, { loading: loadingTemplates || !fontsLoaded, type: type, category: category, separateFromBackground: separateFromBackground, templates: templateList.templates, canViewWithOwnPictures: false })));
};
export default PhotogiftListPageContent;
